import { SainAction } from './hooks/sain-action';

const PEOPLE_TEAMS_LOCATION_MAP: Record<string, Record<string, string>> = {
	userProfilePreview: {
		thirdPartyMessage: 'userProfilePreview-thirdPartyMessage',
		reportingLines: 'userProfilePreview-reportingLines',
		viewProfile: 'userProfilePreview-view-profile',
		recentWorkSection: 'userProfilePreview-recentWork',
		collaboratorsSection: 'userProfilePreview-collaborators',
	},
	userInlinePreview: {
		thirdPartyMessage: 'userInlinePreview-thirdPartyMessage',
		reportingLines: 'userInlinePreview-reportingLines',
		viewProfile: 'userInlinePreview-viewProfile',
	},
	hierarchyChart: {
		managerNode: 'hierarchyChart-managerNode',
		directReportNode: 'hierarchyChart-directReportNode',
		peerNode: 'hierarchyChart-peerNode',
		overflow: 'hierarchyChart-overflow',
		viewFullReportingLine: 'hierarchyChart-viewFullReportingLine',
	},
};

const USER_PROFILE_PREVIEW_TAB_LOCATION_MAP: Record<string, string> = {
	recentWork: 'userProfilePreview-recentWorkTab',
	reportingLine: 'userProfilePreview-reportingLineTab',
	collaborators: 'userProfilePreview-collaboratorsTab',
};

const PEOPLE_TEAMS_ACTION_MAP: Record<string, Record<string, SainAction>> = {
	userProfilePreview: {
		thirdPartyMessage: SainAction.THIRD_PARTY_MESSAGE_CLICKED,
		reportingLines: SainAction.REPORTING_LINES_CLICKED,
		viewProfile: SainAction.VIEW_PROFILE_CLICKED,
		recentWorkSection: SainAction.PROFILE_SECTION_CLICKED,
		collaboratorsSection: SainAction.PROFILE_SECTION_CLICKED,
	},
	userInlinePreview: {
		thirdPartyMessage: SainAction.THIRD_PARTY_MESSAGE_CLICKED,
		reportingLines: SainAction.REPORTING_LINES_CLICKED,
		viewProfile: SainAction.VIEW_PROFILE_CLICKED,
	},
	hierarchyChart: {
		managerNode: SainAction.HIERARCHY_NODE_CLICKED,
		directReportNode: SainAction.HIERARCHY_NODE_CLICKED,
		peerNode: SainAction.HIERARCHY_NODE_CLICKED,
		overflow: SainAction.REPORTING_LINES_CLICKED,
		viewFullReportingLine: SainAction.REPORTING_LINES_CLICKED,
	},
};

export type PeopleTeamsPayload = {
	action?: string;
	actionSubject?: string;
	actionSubjectId?: string;
	renderContext?: string;
	attributes?: { tab?: string };
};

export const resolvePeopleTeamsAnalytics = (
	payload: PeopleTeamsPayload,
): { location: string; sainAction?: SainAction } | undefined => {
	if (payload.action !== 'clicked') {
		return undefined;
	}

	let location: string | undefined;
	let tabSainAction: SainAction | undefined;

	if (payload.actionSubject === 'userProfilePreview' && payload.actionSubjectId === 'tab') {
		const tab = payload.attributes?.tab ?? '';
		location = USER_PROFILE_PREVIEW_TAB_LOCATION_MAP[tab];
		if (location) {
			tabSainAction = SainAction.PROFILE_TAB_CLICKED;
		}
	} else {
		const locationMap = PEOPLE_TEAMS_LOCATION_MAP[payload.actionSubject ?? ''];
		location = locationMap?.[payload.actionSubjectId ?? ''];
	}

	if (!location) {
		return undefined;
	}

	const isCollaborator =
		payload.actionSubject === 'userInlinePreview' && payload.renderContext === 'collaborator';

	if (isCollaborator) {
		location = `${location}-collaborator`;
	}
	const sainAction = isCollaborator
		? SainAction.COLLABORATOR_CLICKED
		: (tabSainAction ??
			PEOPLE_TEAMS_ACTION_MAP[payload.actionSubject ?? '']?.[payload.actionSubjectId ?? '']);

	return { location, sainAction };
};
